import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { featureEnabled } from 'utils';
import { CoopRelationshipDTO } from '@bb/domain/dist/types';
import { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';

import { getCoopRelationshipsForMlsStaff } from 'api/SupraController';
import { Section, SectionTitle } from '../styles';
import MLSUserPageContext from '../MLSUserPageContext';
import { columns } from '../../CoopOrganizationsPage/CoopOrgTable';
import { CoopListTable } from '../../../components';

const CoopSection: React.FC = () => {
  const { user, userId } = useContext(MLSUserPageContext);

  const [coops, setCoops] = useState<CoopRelationshipDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCoopRelationships = async () => {
      const coopRelationships = await getCoopRelationshipsForMlsStaff(userId!);
      setCoops(coopRelationships);
      setLoading(false);
    };

    if (
      featureEnabled('supraAutoCoopFeature') &&
      userId &&
      user?.coopType === SupraCoopType.PRIMARY
    )
      fetchCoopRelationships();
  }, [userId, user?.coopType]);

  if (!userId) return null;

  if (
    !featureEnabled('supraAutoCoopFeature') ||
    user?.coopType !== SupraCoopType.PRIMARY
  ) {
    return null;
  }

  return (
    <Section data-cy="auto-coop-list-section">
      <Container>
        <SectionTitle>Key Cooperating Organizations</SectionTitle>
        <CoopListTable coops={coops} columns={columns} loading={loading} />
      </Container>
    </Section>
  );
};

export default CoopSection;

const Container = styled.div`
  padding: 16px;
`;
